<template><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :panel_required="panel_required" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator" :extra_text="extra_text">

</tile-question-layout></template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Select your internal handle';
                }
            },
            component_id: {
                default(){
                    return 'hardware_handle_internal';
                }
            },
            handleExternal: {
                required: true
            },
            slab: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            openingDirection: {
                required: true
            },
            doorRange: {
                required: true
            },
            profile: {
                required: true
            },
            extra_text: {
              default() {
                return '';
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareColour, this.securedByDesign, this.openingDirection, this.doorRange, this.profile, this.handleExternal);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-handle-internal?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&hardware_colour=' + this.hardwareColour + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange + '&profile=' + this.profile + '&hardware_handle=' + this.handleExternal
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.openingDirection + '_' + this.doorRange + '_' + this.profile + '_' + this.handleExternal;
            },
            panel_required(){
                return this.filtered_option_list.length > 0;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.select_first_after_update = this.select_first_after_update_prop;
                this.update_options();
            },
        }
    }
</script>
